'use client'

import clsx from 'clsx'
import { ChangeEvent, forwardRef, InputHTMLAttributes, useState } from 'react'

import { Text } from '../../Typography'

import cl from './checkbox.module.scss'

const CheckSvg = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8" fill="none" aria-hidden="true">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 1.35145L4.69623 7.3216C4.35287 7.7081 3.7715 7.76916 3.35533 7.46243L0 4.98946L1.12661 3.36199L3.82056 5.34751L8.57118 0L10 1.35145Z"
			fill="#608FF6"
		/>
	</svg>
)

interface CheckboxProps
	extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'checked' | 'onChange' | 'disabled'> {
	label?: string
	defaultChecked?: boolean
	checked?: boolean
	onChange?: (e: ChangeEvent<HTMLInputElement>) => void
	disabled?: boolean
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
	const { label, defaultChecked, className, checked, onChange, disabled, id, ...rest } = props

	const [internalChecked, setInternalChecked] = useState(defaultChecked ?? !!checked)

	const isControlled = checked !== undefined
	const value = isControlled ? checked : internalChecked

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (disabled) return

		if (!isControlled) {
			setInternalChecked(e.target.checked)
		}

		onChange?.(e)
	}

	const rootClassses = clsx(cl.root, className, {
		[cl.root__disabled]: disabled
	})

	return (
		<label className={rootClassses} htmlFor={id}>
			<span className={cl.checkbox}>
				<input
					aria-checked={value}
					ref={ref}
					type="checkbox"
					className={cl.checkbox__input}
					checked={value}
					onChange={handleChange}
					disabled={disabled}
					id={id}
					{...rest}
				/>
				<span className={cl.checkbox__inner}>
					<CheckSvg />
				</span>
			</span>
			{label && <Text as="span">{label}</Text>}
		</label>
	)
})
